import { FormActions } from "../../components/common/FormActions";
import { Table } from "../../components/common/Table";
import { TTableColumn } from "../../types/common";
import { CAN_EDIT_PAYROLL } from "../../utils/constants";
import {
  createViewAction,
  createViewEdit,
  formatDate,
  itemExists,
  numberFormat,
  useGetUserPermissions,
} from "../../utils/helpers";

export const usePayroll = () => {
  const tableColumns = (): TTableColumn[] => [
    { id: "pay_roll_number", header: "Payroll Number" },
    { id: "staff_name", header: "Staff" },
    { id: "role", header: "Role" },
    { id: "bank_account_name", header: "Account Name" },
    { id: "actions", header: "Actions" },
  ];

  const permissions = useGetUserPermissions();
  const canNotEdit = itemExists(permissions, [CAN_EDIT_PAYROLL]);

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      staff_name: item?.staff_user?.full_name,
      role: item?.staff_user?.role_details[0]?.name,
      actions: (
        <FormActions
          actions={createViewEdit("/payrolls", item?.id, canNotEdit)}
        />
      ),
    }));

  const salaryComponentTableColumns = (): TTableColumn[] => [
    { id: "salary_component", header: "Component" },
    { id: "bonus_amount", header: "Bonus Amount" },
    { id: "allowance_amount", header: "Allowance Ammount" },
    { id: "allowance_type_name", header: "Allowance Type" },
    { id: "has_nssf", header: "Has NSSF" },
    { id: "has_paye", header: "Has PAYE" },
    { id: "paye_amount", header: "PAYE Amount" },
    { id: "salary_advancement", header: "Salary Advancement" },
    { id: "advance_payment", header: "Advance Payment" },
    { id: "total_payable", header: "Total Payable" },
    { id: "gross_pay", header: "Gross Pay" },
    { id: "net_pay", header: "Net Pay" },
    // { id: "actions", header: "Actions" },
  ];

  const salaryComponentTableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      has_nssf: item?.has_nssf ? "Yes" : "No",
      has_paye: item?.has_paye ? "Yes" : "No",
      salary_advancement: item?.salary_advancement ? "Yes" : "No",
      gross_pay: numberFormat(item?.gross_pay),
      net_pay: numberFormat(item?.net_pay),
      paye_amount: numberFormat(item?.paye_amount),
      bonus_amount: numberFormat(item?.bonus_amount),
      allowance_amount: numberFormat(item?.allowance_amount),
      total_payable: numberFormat(item?.total_payable),
      advance_payment: numberFormat(item?.advance_payment),

      actions: (
        <FormActions actions={[createViewAction("/payrole_item", item?.id)]} />
      ),
    }));

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Payroll Information",
          fields: {
            pay_roll_number: item?.pay_roll_number,
            bank_account_name: item?.bank_account_name,
            bank_account_number: item?.bank_account_number,
            status: item?.status,
            created_at: formatDate(item?.created_at),
            updated_at: formatDate(item?.updated_at),
          },
        },
        {
          title: "Staff User Information",
          fields: {
            staff_name: item?.staff_user?.full_name,
            role: item?.staff_user?.role_details[0]?.name,
            email: item?.staff_user?.email,
            phone_number: item?.staff_user?.phone_number,
            department: item?.staff_user?.profile?.department,
          },
        },
        {
          title: "Salary Component Details",
          fields: {},
          component: (
            <Table
              loading={false}
              count={item?.salary_components?.count}
              tableTitle="Salary Component Details"
              tableColumns={
                salaryComponentTableColumns ? salaryComponentTableColumns() : []
              }
              tableData={
                item?.salary_components
                  ? salaryComponentTableData(item?.salary_components)
                  : []
              }
              // filters={filters}
              // onFilterChange={setFilter}
              // status={status}
            />
          ),
        },
      ],
    };
  };
  const activityFilter = "payroll";

  return { tableColumns, tableData, viewData, activityFilter };
};
